import { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useNotification } from 'src/contexts/notification.context'
import {
  updatePrintable,
  getSinglePrintable,
  getPrintableThemes,
} from 'src/services/api.service'
import { BackLink } from 'src/components/common'
import { routes } from 'src/navigation/routes'
import { PRINT_STATUS_ENUM } from 'src/tools'
import PrintableForm from './form'
import PrintableStatus from './components/printable-status'

export const ShopEdit = () => {
  const history = useHistory()
  const { wrapCallback } = useNotification()
  const [loaded, setLoaded] = useState(false)
  const [item, setItem] = useState(null)

  const { id } = useParams()

  useEffect(() => {
    wrapCallback(async () => {
      const response = await getSinglePrintable(id)
      const { item } = response.data
      setItem({
        // ...item,
        id: String(item.id),
        topics: item.topics.map((x) => String(x.id)),
        themes: item.themes.map((x) => String(x.id)),

        ages: item.ages,
        subject_id: item.subject_id,

        title: item.title,
        description: item.description,
        sort: item.sort,
        price: item.price,

        pages_count: item.pages_count,

        status: item.status,
        file: item.file || [],
        image: item.image,

        practice_url: item.practice_url,
      })

      setLoaded(true)
    })
  }, [])

  const onSubmit = (values, status) => {
    wrapCallback(async () => {
      await updatePrintable(id, values)

      history.replace(routes.printables.index, {
        step: status === PRINT_STATUS_ENUM.in_review ? 4 : undefined,
      })
    })
  }

  return (
    <>
      <div className="sectionHb-top">
        <BackLink to="/shop" />
        <h2 className="sectionHb-title">
          Edit printable worksheets{' '}
          {item && <PrintableStatus status={item?.status} />}
        </h2>
      </div>

      <div className="sectionHb-block purchaseHb">
        <div className="sectionHb-block__wrap">
          {loaded && (
            <PrintableForm
              initialValues={item}
              item={item}
              onSubmit={onSubmit}
            />
          )}
        </div>
      </div>
    </>
  )
}
